export const getTargetOrigin = () => {
  switch (window.location.origin) {
    case 'https://film3.mogulproductions.com':
      return 'https://mogies.mogulproductions.com';
    case 'https://stage-my.mogulproductions.com':
      return 'https://mogies.mogulproductions.com';
    case 'https://master--priceless-davinci-c582b6.netlify.app':
      return 'https://master--adoring-kilby-e26f6b.netlify.app';
    case 'http://localhost:3000':
      return 'http://localhost:3003';
    default:
      if (window.location.origin.startsWith('https://deploy-preview-')) {
        return (
          window.location.origin.split('--')[0] +
          '--adoring-kilby-e26f6b.netlify.app'
        );
      }
      return 'https://master--adoring-kilby-e26f6b.netlify.app';
  }
};
